/* eslint no-param-reassign: 0 */

import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

export default function BeforeUnload({ children }) {
  const beforeUnloadListener = (evt) => {
    evt.preventDefault()
    evt.returnValue = 'Deseja realmente sair?'
  }

  useEffect(() => {
    window.addEventListener('beforeunload', beforeUnloadListener, { capture: true })

    return (() => {
      window.removeEventListener('beforeunload', beforeUnloadListener, { capture: true })
    })
  })

  return (
    <>
      { children }
    </>
  )
}

BeforeUnload.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node,
    PropTypes.array,
  ]).isRequired,
}
